// extracted by mini-css-extract-plugin
export var chevronIcon = "_4b-2";
export var teamName = "_4b-1";
export var teamSwitcherButton = "_4b-0";